import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import Page from '../../components/Page';
import Button from '../../components/Clickable';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import s from './Brand.scss';
import Link from '../../components/Link';
import { brandMessages as messages } from '../../defineMessages';

const Brand = ({ brands, intl: { formatMessage } }) => {
  const [currentLetter, setCurrentLetter] = useState('');
  const [alphabetLinks, setAlphabetLinks] = useState([]);
  const [brandIndex, setBrandIndex] = useState([]);
  const alphabet = formatMessage({ ...messages.alphabet }).split('');

  useEffect(() => {
    const brandNamesFirstLetter = brands.map(t => t.label[0].toUpperCase());
    const links = [];
    const tmpBrandIndex = [];
    links.push(
      <li>
        <Button
          onClick={() => setCurrentLetter('')}
          className={currentLetter === '' ? s.active : null}
          label={formatMessage({ ...messages.all })}
        />
      </li>,
    );

    alphabet.forEach(letter => {
      if (brandNamesFirstLetter.includes(letter)) {
        const currentBrandNames = [];
        links.push(
          <li>
            <Button
              onClick={() => setCurrentLetter(letter)}
              label={letter}
              key={letter}
              className={currentLetter === letter ? s.active : null}
            />
          </li>,
        );
        if (currentLetter !== '' && currentLetter !== letter) return;
        brands.forEach(brand => {
          if (brand.label[0].toUpperCase() === letter.toUpperCase()) {
            currentBrandNames.push(
              <div className={s.letterBrand}>
                <Link to={brand.to}>{brand.label}</Link>
              </div>,
            );
          }
        });

        tmpBrandIndex.push(
          <div className={s.letterColumn}>
            <div className={s.letterTitle}>{letter}</div>
            <div className={s.letterBrands}>{currentBrandNames}</div>
          </div>,
        );
      } else {
        links.push(
          <li className={s.empty}>
            <Button label={letter} />
          </li>,
        );
      }
    });

    setAlphabetLinks(links);
    setBrandIndex(tmpBrandIndex);
  }, [brands, currentLetter]);

  return (
    <Page>
      <div className={s.mainContainer}>
        <h1 className={s.title}>{formatMessage({ ...messages.brandTitle })}</h1>
        <div className={s.alphabetLinks}>
          <ul>{alphabetLinks}</ul>
        </div>
        {brandIndex}
      </div>
    </Page>
  );
};

Brand.propTypes = {
  brands: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
};

const mapState = state => {
  return {
    brands: state.config.menu.brands,
  };
};

export default compose(
  injectIntl,
  connect(mapState),
  withStyles(s),
  withResponsiveWrapper(),
)(Brand);
